import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import TaskPage from '../pages/Task/Task';
import Documents from '../pages/Documents/Documents';
import Chat from '../pages/Chat/Chat';


const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/task" element={<TaskPage />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/chat" element={<Chat />} />

      </Routes>
    </Router>
  );
}

export default AppRoutes;
